import React from 'react';
import { css } from '@emotion/css';
import { silver_two, dark_grey_blue, color_shades_dark } from '../../constants/colors';
import HorizontalSeparator from './HorizontalSeparator';
import Loader from '../general/Loader';
import styled from '@emotion/styled';
import { breakpoint_small } from '../../constants/breakpoints';

interface SettingsCardProps {
    title?: string
    subtitle?: string
    icon?: string
    bodyStyle?: string
    isLoading?: boolean
}

const SettingsCard: React.FC<SettingsCardProps> = (props) => {
    const LoaderWrapper = styled.div`
        height: 100%;
    `;

    const StyledLoader = styled(Loader)`
        display: flex;
        justify-content: center;
        align-items: center;
    `;

    const cardStyle = css`
        border-radius: 10px;
        background-color: #ffffff;
        border: solid 1px ${silver_two};
        margin-bottom: 32px;
        flex-grow: 0;
        font-family: Muli;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: ${dark_grey_blue};
        h4 {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 24px;
        }
        .section {
            padding: 32px 0;
        }
    `;

    const titleStyle = css`
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 16px;
        padding: 32px 32px ${props?.subtitle?.length > 0 ? 0 : 12}px 32px;
        > h3 {
            font-size: 23px;
            margin: 0 10px;
        }
        ${breakpoint_small} {
            h3 {
                font-size: 18px;
            }
        }
    `;

    const bodyStyle = css`
        padding: 32px;
        ${breakpoint_small} {
            padding: 16px;
        }
    `;

    const descriptionStyle = css`
        color: ${color_shades_dark};
        font-size: 14px;
        font-weight: normal;
        margin: 0 10px;
        padding: 0 32px 12px 32px;
        ${breakpoint_small} {
            padding: 0 16px 16px 16px;
            font-size: 12px;
        }
    `;
    return (
        <>
            {props.isLoading ?
                <LoaderWrapper>
                    <StyledLoader />
                </LoaderWrapper>
                :
                <div className={cardStyle}>

                    {props.title !== undefined ? (
                        <>
                            <div className={titleStyle}>
                                {props.icon !== undefined ? <img src={props.icon} alt="icon" /> : null}
                                <h3>{props.title}</h3>

                            </div>
                            {props?.subtitle?.length > 0 &&
                                <h4 className={descriptionStyle}>{props.subtitle}</h4>
                            }
                            <HorizontalSeparator />
                        </>
                    ) : null}
                    <div className={props.bodyStyle ? props.bodyStyle : bodyStyle}>
                        {props.children}
                    </div>
                </div>
            }
        </>
    );
};

export default SettingsCard;